"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletApi = void 0;
const Ether_1 = require("./Ether");
/**  */
class WalletApi {
    constructor(data) {
        if (data.address) {
            data.address = (0, Ether_1.ethAddress)(data.address);
        }
        let contract;
        for (contract in data.nfts) {
            const lower = (0, Ether_1.ethAddress)(contract);
            if (contract !== lower) {
                data.nfts[lower] = data.nfts[contract];
                delete data.nfts[contract];
            }
        }
        this.wallet = data;
    }
    get address() { return (0, Ether_1.ethAddress)(this.wallet.address); }
    is(flag) {
        return this.wallet.flags[flag];
    }
    hasToken(tokenContract) {
        return tokenContract in this.wallet.nfts && this.wallet.nfts[tokenContract].tokens.length > 0;
    }
    tokensForContract(tokenContract) {
        var _a;
        return (_a = this.wallet.nfts[tokenContract]) === null || _a === void 0 ? void 0 : _a.tokens;
    }
    allTokens() {
        return this.wallet.nfts;
    }
}
exports.WalletApi = WalletApi;
//# sourceMappingURL=Wallet.js.map